import { render, staticRenderFns } from "./AuditTrailView.vue?vue&type=template&id=339d4740"
import script from "./AuditTrailView.vue?vue&type=script&lang=js"
export * from "./AuditTrailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports